module.exports = "#version 300 es\n\nprecision highp float;\n\nin vec4 fs_Pos;\nout vec4 out_Col;\n\nvoid main() {\n  out_Col = vec4(vec3(fs_Pos.z), 1.0); // vec4(fs_Pos.z, fs_Pos.z, gl_FragCoord.z, 1);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/sm-frag.glsl
// module id = 102
// module chunks = 0